import { makeMapFromListOfObjectsAndKey } from 'globals/helpers/helpers';
import { Label } from 'globals/store/events.data';

// Not sure if this is necessary, but trying to be consistent.  However, why not use this everywhere instead of putting helper methods on services?

const VALID_LINK_PATTERN:RegExp = new RegExp('^https?:\/\/(.*)\.(.*)');
export const publicHelpers = {
  urlOk(linkUrl) {
    return VALID_LINK_PATTERN.test(linkUrl)
  },
  strWithBreak(str) { 
    if (!str || typeof str !== 'string') return '';
    return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
  },
  goToUrl(event, url) {
    if (event && event.stopPropagation) event.stopPropagation()
    if (!url) return console.log("LOOKS LIKE YOU FORGOT THE URL!", { event, url })
    if (window['openURL']) window['openURL'](url); // should only be triggering in mobile app
    else window.open(url, '_blank')
  },
  makeDefaultLabels() { 
    return [{ id: 'default01', label: '', color: '#54DDC7', name: 'Green' }, { id: 'default02', label: '', color: '#FFD157', name: 'Yellow' },
    { id: 'default03', label: '', color: '#FF8A5C', name: 'Orange' }, { id: 'default04', label: '', color: '#F05454', name: 'Red' },
    { id: 'default05', label: '', color: '#8270DB', name: 'Purple' }, { id: 'default06', label: '', color: '#A6DBFF', name: 'Blue' }] 
  },
  makeLabelMap(labelList: Label[] = null) {
    return makeMapFromListOfObjectsAndKey<Label>(labelList && labelList.length ? labelList : this.makeDefaultLabels(), 'id')
  },
  openInNewTab(url: string) {
    if (window['openURL']) window['openURL'](url); // should only be triggering in mobile app
    else window.open(url, '_blank')
  },
  openEmail(emailCode: string) {
    console.log(emailCode)
    const a = document.createElement('a');
    a.href = emailCode
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
}

export default publicHelpers